import { useState } from "react";
import { BarChart2, Search } from "lucide-react";
// Dummy demo data for ventures, customers, and statistics
const DEMO_VENTURES = [
  { name: "BBA", color: "bg-teal-500" },
  { name: "HSM", color: "bg-orange-500" },
  { name: "Petal & Forever", color: "bg-pink-500" },
];
const DEMO_CUSTOMERS = [
  { name: "Amira Ford", ventures: ["BBA"], purchases: 3 },
  { name: "Olu Jones", ventures: ["BBA", "HSM"], purchases: 2 },
  { name: "Chidi Lawson", ventures: ["Petal & Forever"], purchases: 5 },
  { name: "Deborah Hill", ventures: ["BBA", "Petal & Forever"], purchases: 1 },
  { name: "Carl Smith", ventures: ["HSM"], purchases: 4 },
];
const VENTURE_COLORS = {
  BBA: "bg-teal-500",
  HSM: "bg-orange-500",
  "Petal & Forever": "bg-pink-500",
  Other: "bg-slate-400",
};

export default function CustomersPage() {
  const [search, setSearch] = useState("");
  // Aggregate counts/frequencies per venture for bar graph
  const ventureCounts = DEMO_VENTURES.map(v => ({
    ...v,
    count: DEMO_CUSTOMERS.filter(c => c.ventures.includes(v.name)).length,
    avgFreq: DEMO_CUSTOMERS.filter(c => c.ventures.includes(v.name)).reduce((acc,cur)=>acc+cur.purchases,0) /
      (DEMO_CUSTOMERS.filter(c => c.ventures.includes(v.name)).length || 1),
  }));
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white dark:from-background dark:to-card py-12 px-3 flex flex-col items-center">
      <div className="w-full max-w-3xl bg-card rounded-xl p-6 shadow-lg mb-8">
        <h1 className="text-2xl font-bold mb-2 flex gap-4 items-center text-primary">
          <BarChart2 className="text-primary"/>
          Global Customer Database
        </h1>
        <p className="mb-6 text-muted-foreground text-base">Compare customer totals and activity across your businesses. Quickly identify overlaps, top buyers, and opportunities.</p>
        {/* Bar chart for total number of customers in each venture */}
        <div className="w-full mt-2 mb-6">
          <div className="flex items-end gap-5 h-40">
            {ventureCounts.map(vc => (
              <div key={vc.name} className="flex flex-col items-center flex-1">
                <div className={`w-12 rounded-t-md ${vc.color} transition-all`} style={{height:Math.max(12,vc.count*30)+"px"}}></div>
                <span className="text-xs font-bold mt-2">{vc.name}</span>
                <span className="text-xs text-muted-foreground">{vc.count} customers</span>
                <span className="text-xs text-primary">Avg freq: {vc.avgFreq.toFixed(1)}</span>
              </div>
            ))}
          </div>
        </div>
        {/* Search bar for customers */}
        <div className="flex items-center gap-2 mb-2">
          <span className="text-muted-foreground"><Search size={18}/></span>
          <input
            type="text"
            className="border bg-background rounded px-3 py-2 w-full text-sm"
            placeholder="Search all customers..."
            value={search}
            onChange={e=>setSearch(e.target.value)}
            aria-label="Search customers"
          />
        </div>
        <div className="overflow-y-auto max-h-80 mt-2 divide-y divide-muted-foreground/10 rounded-lg border">
          {DEMO_CUSTOMERS.filter(c => !search || c.name.toLowerCase().includes(search.toLowerCase()))
            .map((c,i) => (
            <div key={c.name+i} className="py-3 px-4 flex items-center gap-2 hover:bg-muted/60 transition cursor-pointer">
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-primary truncate">{c.name}</div>
                <div className="text-xs text-muted-foreground">
                  {c.purchases} purchase{c.purchases!==1 && "s"}
                </div>
              </div>
              {/* Venture chips */}
              {(c.ventures||[]).map(vName=>(
                <span key={vName} className={`ml-1 px-2 py-0.5 rounded-full text-xs font-bold text-white ${VENTURE_COLORS[vName]||VENTURE_COLORS['Other']}`}>{vName}</span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}